var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 *
 * Dataset reducer
 *
 */
import produce from 'immer';
import { DROP_COMPONENT, LOAD_LAYOUT_SUCCESS, LOAD_LAYOUT_REQUEST, LOAD_LAYOUT_FAILURE, LOAD_STYLE_REQUEST, LOAD_STYLE_SUCCESS, LOAD_STYLE_FAILURE, SAVE_LAYOUT_REQUEST, SAVE_LAYOUT_SUCCESS, SAVE_LAYOUT_FAILURE, SELECT_GRID_COMPONENT, REMOVE_GRID_COMPONENT, CHANGE_BG_COLOR, SET_NAME, OVERRIDE_STYLE, ASSIGN_OUTPUT, ASSIGN_STATE, ON_LAYOUT_CHANGE, CHANGE_PADDING, CHANGE_COMPONENT_VALUE, CHANGE_COMPONENT_MIN_MAX_VALUE, CHANGE_COLOR, LOCK_COMPONENT, ADD_IO, EDIT_IO, REMOVE_IO, LOAD_FOLDERS_REQUEST, LOAD_FOLDERS_SUCCESS, LOAD_FOLDERS_FAILURE, LOAD_FILES_REQUEST, LOAD_FILES_SUCCESS, LOAD_FILES_FAILURE, GET_DATASET_REQUEST, GET_DATASET_SUCCESS, GET_DATASET_FAILURE, RESET_BG_COLOR, CHANGE_BG_IMAGE, RESET_BG_IMAGE, CLOSE_COMPONENT_LIST, OPEN_COMPONENT_LIST, GET_DATASETS_REQUEST, GET_DATASETS_SUCCESS, GET_DATASETS_FAILURE, GET_VIEWS_REQUEST, GET_VIEWS_SUCCESS, GET_VIEWS_FAILURE, CHANGE_VIEW_PADDING, TOGGLE_COMPONENT_EXCLUSIVE, MAX_HEIGHT, MAX_WIDTH, SET_DATASET_SEPARATOR, CHANGE_DATASET_SEPARATOR_COLOR, CHANGE_DATASET_SEPARATOR_HEIGHT, RESET_DATASET_SEPARATOR, ENABLE_OVERRIDE_DATASET_LIST_GROUPING_HEADER, CHANGE_DATASET_LIST_GROUPING_HEADER_FIELDS, RESET_DATASET_LIST_GROUPING_HEADER_FIELDS, SET_FULLSCREEN, SET_FLOW, TOGGLE_PORTRAIT, TOGGLE_ORIENTATION, TOGGLE_FONT_SCALLING, CHANGE_DEVICE_SCALE, RESET_LAYOUT, CHANGE_COMPONENT_DIMENSIONS, GET_DATASET_FIELDS_REQUEST, GET_DATASET_FIELDS_SUCCESS, GET_DATASET_FIELDS_FAILURE, UPDATE_GROUPED_SELECTED_COMPONENTS, UPDATE_GROUP_SELECTION, GET_DATASET_ROWS_REQUEST, GET_DATASET_ROWS_SUCCESS, GET_DATASET_ROWS_FAILURE, SAVE_DATASET_NON_LIST_LAYOUT_REQUEST, SAVE_DATASET_NON_LIST_LAYOUT_SUCCESS, SAVE_DATASET_NON_LIST_LAYOUT_FAILURE, SAVE_LIST_VIEW_LAYOUT_REQUEST, UPDATE_SELECTED_TAB, ADD_COMPONENT_STATE_SELECTED_COMPONENT, UPDATE_LOGIC_SELECETD_COMPONENT_STATE, DELETE_COMPONENT_STATE, UPDATE_COMPONENT_STATE_NAME, COPY_COMPONENT_STATE, GET_DATASET_RULES_REQUEST, GET_DATASET_RULES_SUCCESS, GET_DATASET_RULES_FAILURE, OPEN_MODAL, CHANGE_CUSTOM_STYLES, TOGGLE_LIST_ITEM_BORDER, SET_LIST_ITEM_BORDER_PROPERTY, LOAD_STORAGE_REQUEST, LOAD_STORAGE_SUCCESS, LOAD_STORAGE_FAILURE, } from './constants';
import { transformLayoutWithStyle, toLayoutObject, toVBLayout, toLayout, compactFlowLayout, clearGroupAreas, } from './helpers';
import { generateUUID } from '@project/utils';
import { initialState as stylesInitialState } from '../../StylesPage/reducer';
import { DRAGGING_ITEM_NAME } from '@project/components/ViewBuilder/constants';
import { defaultStyles } from '../../../components/ViewBuilder/Sidebar/RichTextCustomStyleModal/constants';
export var initialState = {
    name: '',
    type: '',
    version: '',
    fullscreen: true,
    bgColor: stylesInitialState.data.backgroundColor,
    bgImage: {
        source: '',
        size: 'cover',
    },
    unstyledLayout: {},
    layout: {},
    vbLayout: {},
    componentCopy: null,
    portrait: true,
    hasLandscape: false,
    fontScalingAllowed: false,
    flow: true,
    separator: false,
    separatorColor: '#dddddd',
    separatorHeight: 1,
    enableListItemBorder: false,
    listItemBorder: {
        borderStyle: 'solid',
        borderTopWidth: 0,
        borderTopColor: '#eeeeee',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomColor: '#eeeeee',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderLeftColor: '#eeeeee',
        borderRightWidth: 0,
        borderRightColor: '#eeeeee',
    },
    groupingHeader: {
        backgroundColor: '#eeeeee',
        fontColor: '#cccccc',
        fontFamily: 'System',
        fontWeight: 'bold',
        fontSize: 12,
        fontStyle: 'normal',
        textDecorationLine: 'none',
        textTransform: 'none',
        textShadowColor: '#cccccc',
        textShadowRadius: 0,
        letterSpacing: 0,
        numberOfLines: 1,
        ellipsizeMode: 'tail',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderLeftColor: '#eeeeee',
        borderLeftWidth: 0,
        borderRightColor: '#eeeeee',
        borderRightWidth: 0,
        borderTopColor: '#eeeeee',
        borderTopWidth: 0,
        borderBottomColor: '#eeeeee',
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    scale: 'default',
    inputs: [],
    outputs: [],
    folders: [],
    states: {
        defaultStates: {},
        list: [],
    },
    foldersMeta: {},
    files: [],
    filesMeta: {},
    meta: {},
    icons: [],
    selectedComponentId: '',
    groupedSelectedComponents: [],
    datasets_loading: false,
    styles_loading: false,
    loading: false,
    error: false,
    accessibility: {
        accessible: false,
        accessibilityLabel: '',
        accessibilityHint: '',
    },
    overrideBackground: false,
    overrideDatalistGroupingHeader: false,
    componentListIsOpen: true,
    style: { data: stylesInitialState.data },
    padding: {
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
    },
    saving: false,
    datasets: [],
    views: [],
    datasetFields_loading: false,
    datasetFields: [],
    datasetRows: [],
    dataset: {
        id: '',
        view_options: {
            list: {
                flow: true,
                hasLandscape: false,
                fontScalingAllowed: false,
                layout: {},
                inputs: [],
                background_color: 'unset',
                background_image: {
                    source: '',
                    size: '',
                },
                padding: {
                    bottom: 0,
                    left: 0,
                    right: 0,
                    top: 0,
                },
                separator: false,
                separatorHeight: 0,
                separatorColor: '#dddddd',
                listItemBorder: {
                    borderStyle: 'solid',
                    borderTopWidth: 0,
                    borderTopColor: '#eeeeee',
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    borderBottomWidth: 0,
                    borderBottomColor: '#eeeeee',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    borderLeftWidth: 0,
                    borderLeftColor: '#eeeeee',
                    borderRightWidth: 0,
                    borderRightColor: '#eeeeee',
                },
                groupingHeader: {
                    backgroundColor: '#eeeeee',
                    fontColor: '#cccccc',
                    fontFamily: 'System',
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontStyle: 'normal',
                    textDecorationLine: 'none',
                    textTransform: 'none',
                    textShadowColor: '#cccccc',
                    textShadowRadius: 0,
                    letterSpacing: 0,
                    numberOfLines: 1,
                    ellipsizeMode: 'tail',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    borderLeftColor: '#eeeeee',
                    borderLeftWidth: 0,
                    borderRightColor: '#eeeeee',
                    borderRightWidth: 0,
                    borderTopColor: '#eeeeee',
                    borderTopWidth: 0,
                    borderBottomColor: '#eeeeee',
                    borderBottomWidth: 0,
                    borderStyle: 'solid',
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                },
            },
            calendar: {},
            grid: {},
            map: {
                centerCoordinate: {
                    lat: 57.698329,
                    lon: 11.9860685,
                    zoom: 10,
                },
            },
        },
    },
    calendar: {},
    grid: {},
    map: {
        centerCoordinate: {
            lat: 57.698329,
            lon: 11.9860685,
            zoom: 10,
        },
    },
    selectedTab: 'default',
    datasetRules: [],
    localStorage: [],
    customStyleModal: false,
    views_loading: false,
};
function colourPreviewReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143;
        switch (action.type) {
            case RESET_LAYOUT:
                return initialState;
            case ADD_IO:
                state[action.ioType].push(action.io);
                state.saving = true;
                break;
            case OPEN_MODAL:
                state.customStyleModal = action.modal;
                break;
            case CHANGE_CUSTOM_STYLES:
                state.saving = true;
                break;
            case ASSIGN_OUTPUT:
                if (state.selectedTab && state.selectedTab !== 'default') {
                    state.layout[action.componentId].component_states[state.selectedTab].properties.output.name = action.value;
                    state.vbLayout[action.componentId].properties.output.name =
                        action.value;
                }
                else {
                    state.layout[action.componentId].properties.output.name =
                        action.value;
                    state.vbLayout[action.componentId].properties.output.name =
                        action.value;
                }
                state.saving = true;
                break;
            case ASSIGN_STATE:
                if (state.selectedTab && state.selectedTab !== 'default') {
                    state.layout[action.componentId].component_states[state.selectedTab].properties.state.name = action.value;
                    state.vbLayout[action.componentId].properties.state.name =
                        action.value;
                    state.saving = true;
                }
                else {
                    state.layout[action.componentId].properties.state.name = action.value;
                    state.vbLayout[action.componentId].properties.state.name =
                        action.value;
                    state.saving = true;
                }
                break;
            case CHANGE_BG_COLOR:
                state.bgColor = action.value;
                state.overrideBackground = action.override;
                state.saving = true;
                break;
            case TOGGLE_PORTRAIT:
                state.portrait = action.portrait;
                state.vbLayout = toVBLayout(currentState.layout, action.portrait, currentState.scale);
                break;
            case CHANGE_DEVICE_SCALE:
                state.scale = action.scale;
                state.vbLayout = toVBLayout(currentState.layout, currentState.portrait, action.scale);
                break;
            case CHANGE_BG_IMAGE:
                state.bgImage = action.value;
                state.overrideBackground = action.override;
                state.saving = true;
                break;
            case CHANGE_COLOR:
                if (state.selectedTab && state.selectedTab !== 'default') {
                    state.layout[action.componentId].component_states[state.selectedTab].properties.style[action.field].value = action.value;
                    state.vbLayout[action.componentId].properties.style[action.field].value = action.value;
                }
                else {
                    state.layout[action.componentId].properties.style[action.field].value = action.value;
                    state.vbLayout[action.componentId].properties.style[action.field].value = action.value;
                }
                state.saving = true;
                break;
            case CHANGE_COMPONENT_VALUE:
                if (state.selectedTab && state.selectedTab !== 'default') {
                    if (action.fieldType === 'customStyles') {
                        state.layout[action.componentId].component_states[state.selectedTab].properties = __assign(__assign({}, state.layout[action.componentId].component_states[state.selectedTab].properties), (_a = {}, _a[action.fieldType] = action.value, _a));
                        state.vbLayout[action.componentId].properties = __assign(__assign({}, state.layout[action.componentId].properties), (_b = {}, _b[action.fieldType] = action.value, _b));
                    }
                    else {
                        if (state.layout[action.componentId].component_states[state.selectedTab].properties[action.fieldType][action.field]) {
                            state.layout[action.componentId].component_states[state.selectedTab].properties[action.fieldType][action.field].value = action.value;
                        }
                        if (state.vbLayout[action.componentId].properties[action.fieldType][action.field]) {
                            state.vbLayout[action.componentId].properties[action.fieldType][action.field].value = action.value;
                        }
                    }
                }
                else {
                    if (action.fieldType === 'customStyles') {
                        state.layout[action.componentId].properties = __assign(__assign({}, state.layout[action.componentId].properties), (_c = {}, _c[action.fieldType] = action.value, _c));
                        state.vbLayout[action.componentId].properties = __assign(__assign({}, state.layout[action.componentId].properties), (_d = {}, _d[action.fieldType] = action.value, _d));
                    }
                    else {
                        if (state.layout[action.componentId].properties[action.fieldType][action.field]) {
                            state.layout[action.componentId].properties[action.fieldType][action.field].value = action.value;
                        }
                        if (state.vbLayout[action.componentId].properties[action.fieldType][action.field]) {
                            state.vbLayout[action.componentId].properties[action.fieldType][action.field].value = action.value;
                        }
                    }
                }
                state.saving = true;
                break;
            case TOGGLE_COMPONENT_EXCLUSIVE: {
                var component = state.layout[action.componentId];
                state.saving = true;
                component.properties.other.exclusive.value =
                    !component.properties.other.exclusive.value;
                if (component.properties.other.exclusive.value) {
                    var newLayoutArray = Object.values(state.layout).filter(function (m) { return m.i === action.componentId; });
                    var currentScale = component.scale[state.scale];
                    currentScale.h = MAX_HEIGHT;
                    currentScale.w = MAX_WIDTH;
                    currentScale.x = 0;
                    currentScale.y = 0;
                    currentScale.landscape.h = currentScale.w;
                    currentScale.landscape.w = currentScale.h;
                    currentScale.landscape.x = 0;
                    currentScale.landscape.y = 0;
                    component.scale[state.scale] = currentScale;
                    component.static = true;
                    var layoutObj = toLayoutObject(newLayoutArray);
                    state.layout = layoutObj;
                    state.vbLayout = toVBLayout(layoutObj, currentState.portrait, currentState.scale);
                }
                else {
                    var currentScale = component.scale[state.scale];
                    currentScale.h = action.componentDefinition.h;
                    currentScale.landscape.w = action.componentDefinition.h;
                    component.static = false;
                    state.vbLayout = toVBLayout(state.layout, currentState.portrait, currentState.scale);
                }
                break;
            }
            case CHANGE_COMPONENT_MIN_MAX_VALUE:
                if (state.selectedTab && state.selectedTab !== 'default') {
                    state.layout[action.componentId].component_states[state.selectedTab].properties[action.fieldType][action.field][action.minMaxValue].value = action.value;
                    state.vbLayout[action.componentId].properties[action.fieldType][action.field][action.minMaxValue].value = action.value;
                }
                else {
                    state.layout[action.componentId].properties[action.fieldType][action.field][action.minMaxValue].value = action.value;
                    state.vbLayout[action.componentId].properties[action.fieldType][action.field][action.minMaxValue].value = action.value;
                }
                state.saving = true;
                break;
            case CHANGE_PADDING:
                if (state.selectedTab && state.selectedTab !== 'default') {
                    state.layout[action.componentId].component_states[state.selectedTab].properties.style[action.key][action.field].value = action.value;
                    state.vbLayout[action.componentId].properties.style[action.key][action.field].value = action.value;
                }
                else {
                    state.layout[action.componentId].properties.style[action.key][action.field].value = action.value;
                    state.vbLayout[action.componentId].properties.style[action.key][action.field].value = action.value;
                }
                state.saving = true;
                break;
            case CLOSE_COMPONENT_LIST:
                state.componentListIsOpen = false;
                break;
            case DROP_COMPONENT: {
                state.selectedTab = 'default';
                var newLayout_1 = Object.values(currentState.layout)
                    .filter(function (l) {
                    return l.i !== DRAGGING_ITEM_NAME &&
                        l.i !== 'undefined' &&
                        l.i !== 'null';
                })
                    .reduce(function (acc, l) {
                    if (!l) {
                        return acc;
                    }
                    acc[l.i] = l;
                    return acc;
                }, {});
                if (action &&
                    action.component &&
                    action.component.i !== DRAGGING_ITEM_NAME) {
                    newLayout_1[action.component.i] = action.component;
                    state.selectedComponentId = action.component.i;
                }
                if (action &&
                    action.component &&
                    action.component.label === 'Rich Text') {
                    var customStyles = ((_j = newLayout_1[action.component.i].properties) === null || _j === void 0 ? void 0 : _j.customStyles) || { h1: {} };
                    if (((_k = Object.keys((customStyles === null || customStyles === void 0 ? void 0 : customStyles.h1) || {})) === null || _k === void 0 ? void 0 : _k.length) === 0) {
                        newLayout_1[action.component.i].properties = __assign(__assign({}, newLayout_1[action.component.i].properties), { customStyles: defaultStyles });
                    }
                }
                state.layout = newLayout_1;
                state.vbLayout = toVBLayout(newLayout_1, currentState.portrait, currentState.scale);
                state.saving = true;
                break;
            }
            case EDIT_IO:
                state[action.ioType][state[action.ioType].findIndex(function (io) { return io.id === action.id; })] = action.io;
                state.saving = true;
                break;
            case GET_DATASETS_REQUEST:
                state.datasets_loading = true;
                state.error = false;
                break;
            case GET_DATASETS_SUCCESS:
                state.datasets_loading = false;
                state.error = false;
                state.datasets = action.datasets;
                break;
            case GET_DATASETS_FAILURE:
                state.datasets_loading = false;
                state.error = true;
                break;
            case GET_VIEWS_REQUEST:
                state.views_loading = true;
                state.error = false;
                break;
            case GET_VIEWS_SUCCESS:
                state.views_loading = false;
                state.error = false;
                state.views = action.views;
                break;
            case GET_VIEWS_FAILURE:
                state.views_loading = false;
                break;
            case GET_DATASET_FIELDS_REQUEST:
                state.datasetFields_loading = true;
                state.error = false;
                break;
            case GET_DATASET_FIELDS_SUCCESS:
                state.datasetFields_loading = false;
                state.error = false;
                state.datasetFields = action.fields;
                break;
            case GET_DATASET_FIELDS_FAILURE:
                state.datasetFields_loading = false;
                state.error = true;
                break;
            case LOAD_LAYOUT_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_LAYOUT_SUCCESS: {
                state.meta = (_l = action.payload) === null || _l === void 0 ? void 0 : _l.meta;
                state.name = (_m = action.payload) === null || _m === void 0 ? void 0 : _m.name;
                state.type = (_o = action.payload) === null || _o === void 0 ? void 0 : _o.type;
                state.version = (_p = action.payload) === null || _p === void 0 ? void 0 : _p.version;
                state.accessibility =
                    ((_r = (_q = action.payload) === null || _q === void 0 ? void 0 : _q.settings) === null || _r === void 0 ? void 0 : _r.accessibility) || initialState.accessibility;
                state.bgColor = ((_s = action.payload) === null || _s === void 0 ? void 0 : _s.background_color) || '#ffffff';
                state.padding = (_t = action.payload) === null || _t === void 0 ? void 0 : _t.padding;
                state.hasLandscape = (_v = (_u = action.payload) === null || _u === void 0 ? void 0 : _u.settings) === null || _v === void 0 ? void 0 : _v.hasLandscape;
                state.fontScalingAllowed = (_x = (_w = action.payload) === null || _w === void 0 ? void 0 : _w.settings) === null || _x === void 0 ? void 0 : _x.fontScalingAllowed;
                state.fullscreen = (_z = (_y = action.payload) === null || _y === void 0 ? void 0 : _y.settings) === null || _z === void 0 ? void 0 : _z.fullscreen;
                state.flow = (_1 = (_0 = action.payload) === null || _0 === void 0 ? void 0 : _0.settings) === null || _1 === void 0 ? void 0 : _1.flow;
                state.calendar = (_3 = (_2 = action.payload) === null || _2 === void 0 ? void 0 : _2.settings) === null || _3 === void 0 ? void 0 : _3.calendar;
                state.map = (_5 = (_4 = action.payload) === null || _4 === void 0 ? void 0 : _4.settings) === null || _5 === void 0 ? void 0 : _5.map;
                state.grid = (_7 = (_6 = action.payload) === null || _6 === void 0 ? void 0 : _6.settings) === null || _7 === void 0 ? void 0 : _7.grid;
                if ((_9 = (_8 = action.payload) === null || _8 === void 0 ? void 0 : _8.settings) === null || _9 === void 0 ? void 0 : _9.separator)
                    state.separator = (_11 = (_10 = action.payload) === null || _10 === void 0 ? void 0 : _10.settings) === null || _11 === void 0 ? void 0 : _11.separator;
                if ((_13 = (_12 = action.payload) === null || _12 === void 0 ? void 0 : _12.settings) === null || _13 === void 0 ? void 0 : _13.separatorColor)
                    state.separatorColor = (_15 = (_14 = action.payload) === null || _14 === void 0 ? void 0 : _14.settings) === null || _15 === void 0 ? void 0 : _15.separatorColor;
                if ((_17 = (_16 = action.payload) === null || _16 === void 0 ? void 0 : _16.settings) === null || _17 === void 0 ? void 0 : _17.separatorHeight)
                    state.separatorHeight = (_19 = (_18 = action.payload) === null || _18 === void 0 ? void 0 : _18.settings) === null || _19 === void 0 ? void 0 : _19.separatorHeight;
                if ((_21 = (_20 = action.payload) === null || _20 === void 0 ? void 0 : _20.settings) === null || _21 === void 0 ? void 0 : _21.groupingHeader)
                    state.groupingHeader = (_23 = (_22 = action.payload) === null || _22 === void 0 ? void 0 : _22.settings) === null || _23 === void 0 ? void 0 : _23.groupingHeader;
                if ((_25 = (_24 = action.payload) === null || _24 === void 0 ? void 0 : _24.settings) === null || _25 === void 0 ? void 0 : _25.enableListItemBorder)
                    state.enableListItemBorder =
                        (_27 = (_26 = action.payload) === null || _26 === void 0 ? void 0 : _26.settings) === null || _27 === void 0 ? void 0 : _27.enableListItemBorder;
                if ((_29 = (_28 = action.payload) === null || _28 === void 0 ? void 0 : _28.settings) === null || _29 === void 0 ? void 0 : _29.listItemBorder)
                    state.listItemBorder = (_31 = (_30 = action.payload) === null || _30 === void 0 ? void 0 : _30.settings) === null || _31 === void 0 ? void 0 : _31.listItemBorder;
                if (action.payload.type === 'list') {
                    state.overrideDatalistGroupingHeader =
                        ((_34 = (_33 = (_32 = action.payload) === null || _32 === void 0 ? void 0 : _32.settings) === null || _33 === void 0 ? void 0 : _33.groupingHeader) === null || _34 === void 0 ? void 0 : _34.backgroundColor) !==
                            initialState.groupingHeader.backgroundColor ||
                            ((_37 = (_36 = (_35 = action.payload) === null || _35 === void 0 ? void 0 : _35.settings) === null || _36 === void 0 ? void 0 : _36.groupingHeader) === null || _37 === void 0 ? void 0 : _37.fontColor) !==
                                initialState.groupingHeader.fontColor ||
                            ((_40 = (_39 = (_38 = action.payload) === null || _38 === void 0 ? void 0 : _38.settings) === null || _39 === void 0 ? void 0 : _39.groupingHeader) === null || _40 === void 0 ? void 0 : _40.fontFamily) !==
                                initialState.groupingHeader.fontFamily ||
                            ((_43 = (_42 = (_41 = action.payload) === null || _41 === void 0 ? void 0 : _41.settings) === null || _42 === void 0 ? void 0 : _42.groupingHeader) === null || _43 === void 0 ? void 0 : _43.fontSize) !==
                                initialState.groupingHeader.fontSize ||
                            ((_46 = (_45 = (_44 = action.payload) === null || _44 === void 0 ? void 0 : _44.settings) === null || _45 === void 0 ? void 0 : _45.groupingHeader) === null || _46 === void 0 ? void 0 : _46.fontWeight) !==
                                initialState.groupingHeader.fontWeight ||
                            ((_49 = (_48 = (_47 = action.payload) === null || _47 === void 0 ? void 0 : _47.settings) === null || _48 === void 0 ? void 0 : _48.groupingHeader) === null || _49 === void 0 ? void 0 : _49.fontStyle) !==
                                initialState.groupingHeader.fontStyle ||
                            ((_52 = (_51 = (_50 = action.payload) === null || _50 === void 0 ? void 0 : _50.settings) === null || _51 === void 0 ? void 0 : _51.groupingHeader) === null || _52 === void 0 ? void 0 : _52.textDecorationLine) !==
                                initialState.groupingHeader.textDecorationLine ||
                            ((_55 = (_54 = (_53 = action.payload) === null || _53 === void 0 ? void 0 : _53.settings) === null || _54 === void 0 ? void 0 : _54.groupingHeader) === null || _55 === void 0 ? void 0 : _55.textTransform) !==
                                initialState.groupingHeader.textTransform ||
                            ((_58 = (_57 = (_56 = action.payload) === null || _56 === void 0 ? void 0 : _56.settings) === null || _57 === void 0 ? void 0 : _57.groupingHeader) === null || _58 === void 0 ? void 0 : _58.textShadowColor) !==
                                initialState.groupingHeader.textShadowColor ||
                            ((_61 = (_60 = (_59 = action.payload) === null || _59 === void 0 ? void 0 : _59.settings) === null || _60 === void 0 ? void 0 : _60.groupingHeader) === null || _61 === void 0 ? void 0 : _61.textShadowRadius) !==
                                initialState.groupingHeader.textShadowRadius ||
                            ((_64 = (_63 = (_62 = action.payload) === null || _62 === void 0 ? void 0 : _62.settings) === null || _63 === void 0 ? void 0 : _63.groupingHeader) === null || _64 === void 0 ? void 0 : _64.letterSpacing) !==
                                initialState.groupingHeader.letterSpacing ||
                            ((_67 = (_66 = (_65 = action.payload) === null || _65 === void 0 ? void 0 : _65.settings) === null || _66 === void 0 ? void 0 : _66.groupingHeader) === null || _67 === void 0 ? void 0 : _67.ellipsizeMode) !==
                                initialState.groupingHeader.ellipsizeMode ||
                            ((_70 = (_69 = (_68 = action.payload) === null || _68 === void 0 ? void 0 : _68.settings) === null || _69 === void 0 ? void 0 : _69.groupingHeader) === null || _70 === void 0 ? void 0 : _70.flexDirection) !==
                                initialState.groupingHeader.flexDirection ||
                            ((_73 = (_72 = (_71 = action.payload) === null || _71 === void 0 ? void 0 : _71.settings) === null || _72 === void 0 ? void 0 : _72.groupingHeader) === null || _73 === void 0 ? void 0 : _73.justifyContent) !==
                                initialState.groupingHeader.justifyContent ||
                            ((_76 = (_75 = (_74 = action.payload) === null || _74 === void 0 ? void 0 : _74.settings) === null || _75 === void 0 ? void 0 : _75.groupingHeader) === null || _76 === void 0 ? void 0 : _76.alignItems) !==
                                initialState.groupingHeader.alignItems ||
                            ((_79 = (_78 = (_77 = action.payload) === null || _77 === void 0 ? void 0 : _77.settings) === null || _78 === void 0 ? void 0 : _78.groupingHeader) === null || _79 === void 0 ? void 0 : _79.paddingTop) !==
                                initialState.groupingHeader.paddingTop ||
                            ((_82 = (_81 = (_80 = action.payload) === null || _80 === void 0 ? void 0 : _80.settings) === null || _81 === void 0 ? void 0 : _81.groupingHeader) === null || _82 === void 0 ? void 0 : _82.paddingBottom) !==
                                initialState.groupingHeader.paddingBottom ||
                            ((_85 = (_84 = (_83 = action.payload) === null || _83 === void 0 ? void 0 : _83.settings) === null || _84 === void 0 ? void 0 : _84.groupingHeader) === null || _85 === void 0 ? void 0 : _85.paddingLeft) !==
                                initialState.groupingHeader.paddingLeft ||
                            ((_88 = (_87 = (_86 = action.payload) === null || _86 === void 0 ? void 0 : _86.settings) === null || _87 === void 0 ? void 0 : _87.groupingHeader) === null || _88 === void 0 ? void 0 : _88.paddingRight) !==
                                initialState.groupingHeader.paddingRight ||
                            ((_91 = (_90 = (_89 = action.payload) === null || _89 === void 0 ? void 0 : _89.settings) === null || _90 === void 0 ? void 0 : _90.groupingHeader) === null || _91 === void 0 ? void 0 : _91.borderLeftColor) !==
                                initialState.groupingHeader.borderLeftColor ||
                            ((_94 = (_93 = (_92 = action.payload) === null || _92 === void 0 ? void 0 : _92.settings) === null || _93 === void 0 ? void 0 : _93.groupingHeader) === null || _94 === void 0 ? void 0 : _94.borderLeftWidth) !==
                                initialState.groupingHeader.borderLeftWidth ||
                            ((_97 = (_96 = (_95 = action.payload) === null || _95 === void 0 ? void 0 : _95.settings) === null || _96 === void 0 ? void 0 : _96.groupingHeader) === null || _97 === void 0 ? void 0 : _97.borderRightColor) !==
                                initialState.groupingHeader.borderRightColor ||
                            ((_100 = (_99 = (_98 = action.payload) === null || _98 === void 0 ? void 0 : _98.settings) === null || _99 === void 0 ? void 0 : _99.groupingHeader) === null || _100 === void 0 ? void 0 : _100.borderRightWidth) !==
                                initialState.groupingHeader.borderRightWidth ||
                            ((_103 = (_102 = (_101 = action.payload) === null || _101 === void 0 ? void 0 : _101.settings) === null || _102 === void 0 ? void 0 : _102.groupingHeader) === null || _103 === void 0 ? void 0 : _103.borderTopColor) !==
                                initialState.groupingHeader.borderTopColor ||
                            ((_106 = (_105 = (_104 = action.payload) === null || _104 === void 0 ? void 0 : _104.settings) === null || _105 === void 0 ? void 0 : _105.groupingHeader) === null || _106 === void 0 ? void 0 : _106.borderTopWidth) !==
                                initialState.groupingHeader.borderTopWidth ||
                            ((_109 = (_108 = (_107 = action.payload) === null || _107 === void 0 ? void 0 : _107.settings) === null || _108 === void 0 ? void 0 : _108.groupingHeader) === null || _109 === void 0 ? void 0 : _109.borderBottomColor) !==
                                initialState.groupingHeader.borderBottomColor ||
                            ((_112 = (_111 = (_110 = action.payload) === null || _110 === void 0 ? void 0 : _110.settings) === null || _111 === void 0 ? void 0 : _111.groupingHeader) === null || _112 === void 0 ? void 0 : _112.borderBottomWidth) !==
                                initialState.groupingHeader.borderBottomWidth ||
                            ((_115 = (_114 = (_113 = action.payload) === null || _113 === void 0 ? void 0 : _113.settings) === null || _114 === void 0 ? void 0 : _114.groupingHeader) === null || _115 === void 0 ? void 0 : _115.borderStyle) !==
                                initialState.groupingHeader.borderStyle ||
                            ((_118 = (_117 = (_116 = action.payload) === null || _116 === void 0 ? void 0 : _116.settings) === null || _117 === void 0 ? void 0 : _117.groupingHeader) === null || _118 === void 0 ? void 0 : _118.borderTopLeftRadius) !==
                                initialState.groupingHeader.borderTopLeftRadius ||
                            ((_121 = (_120 = (_119 = action.payload) === null || _119 === void 0 ? void 0 : _119.settings) === null || _120 === void 0 ? void 0 : _120.groupingHeader) === null || _121 === void 0 ? void 0 : _121.borderTopRightRadius) !==
                                initialState.groupingHeader.borderTopRightRadius ||
                            ((_124 = (_123 = (_122 = action.payload) === null || _122 === void 0 ? void 0 : _122.settings) === null || _123 === void 0 ? void 0 : _123.groupingHeader) === null || _124 === void 0 ? void 0 : _124.borderBottomLeftRadius) !==
                                initialState.groupingHeader.borderBottomLeftRadius ||
                            ((_127 = (_126 = (_125 = action.payload) === null || _125 === void 0 ? void 0 : _125.settings) === null || _126 === void 0 ? void 0 : _126.groupingHeader) === null || _127 === void 0 ? void 0 : _127.borderBottomRightRadius) !==
                                initialState.groupingHeader.borderBottomRightRadius;
                }
                if ((_128 = action.payload) === null || _128 === void 0 ? void 0 : _128.background_image) {
                    state.bgImage = (_129 = action.payload) === null || _129 === void 0 ? void 0 : _129.background_image;
                }
                state.unstyledLayout = JSON.parse(JSON.stringify(((_130 = action.payload) === null || _130 === void 0 ? void 0 : _130.layout) || {}));
                state.layout = JSON.parse(JSON.stringify(((_131 = action.payload) === null || _131 === void 0 ? void 0 : _131.layout) || {}));
                var styledLayout = transformLayoutWithStyle(state.layout, state.style);
                state.vbLayout = toVBLayout(styledLayout, currentState.portrait, currentState.scale);
                if (Object.keys(state.layout).length > 0) {
                    state.componentListIsOpen = false;
                }
                state.overrideBackground =
                    state.bgColor !== 'unset' &&
                        (state.bgColor !== state.style.data.backgroundColor ||
                            state.bgImage.source !== '');
                state.inputs =
                    ((_132 = action.payload) === null || _132 === void 0 ? void 0 : _132.inputs.map(function (input) { return (__assign(__assign({}, input), { id: generateUUID().slice(0, 10) })); })) || [];
                state.outputs =
                    ((_133 = action.payload) === null || _133 === void 0 ? void 0 : _133.outputs.map(function (output) { return (__assign(__assign({}, output), { id: generateUUID().slice(0, 10) })); })) || [];
                state.states.list =
                    ((_135 = (_134 = action.payload) === null || _134 === void 0 ? void 0 : _134.statesList) === null || _135 === void 0 ? void 0 : _135.map(function (s) { return (__assign(__assign({}, s), { id: generateUUID().slice(0, 10) })); })) || [];
                var formattedDefaultValues_1 = {};
                (_136 = action.payload.statesList) === null || _136 === void 0 ? void 0 : _136.forEach(function (item) {
                    formattedDefaultValues_1[item.key] = {
                        setDefault: false,
                        label: item.label,
                    };
                });
                (_137 = action.payload.states) === null || _137 === void 0 ? void 0 : _137.forEach(function (item) {
                    var _a, _b;
                    formattedDefaultValues_1[item.key] = {
                        setDefault: item.setDefault,
                        label: (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.statesList.find(function (i) { return i.key === item.key; })) === null || _b === void 0 ? void 0 : _b.label,
                    };
                });
                state.states.defaultStates = formattedDefaultValues_1;
                state.loading = false;
                state.error = false;
                break;
            }
            case LOAD_LAYOUT_FAILURE:
                state.name = initialState.name;
                state.accessibility = initialState.accessibility;
                state.bgColor = initialState.bgColor;
                state.unstyledLayout = initialState.unstyledLayout;
                state.layout = initialState.layout;
                state.vbLayout = toVBLayout(initialState.layout, currentState.portrait, currentState.scale);
                state.inputs = initialState.inputs;
                state.outputs = initialState.outputs;
                state.loading = false;
                state.error = action.err;
                break;
            case LOAD_STYLE_REQUEST:
                state.loading = true;
                state.error = false;
                state.styles_loading = true;
                break;
            case LOAD_STYLE_SUCCESS: {
                state.style = action.style;
                var styledLayout = transformLayoutWithStyle(JSON.parse(JSON.stringify(currentState.unstyledLayout)), state.style);
                state.vbLayout = toVBLayout(styledLayout, currentState.portrait, currentState.scale);
                state.overrideBackground =
                    currentState.bgColor !== 'unset' &&
                        (currentState.bgColor !== currentState.style.data.backgroundColor ||
                            currentState.bgImage.source !== '');
                state.loading = false;
                state.error = false;
                state.styles_loading = false;
                break;
            }
            case LOAD_STYLE_FAILURE:
                state.style = initialState.style;
                state.loading = false;
                state.error = action.err;
                state.styles_loading = false;
                break;
            case LOCK_COMPONENT:
                state.layout[action.componentId].static = action.value;
                state.vbLayout[action.componentId].static = action.value;
                state.saving = true;
                break;
            case ON_LAYOUT_CHANGE: {
                var vbLayout = action.vbLayout;
                state.saving = true;
                if (vbLayout && Array.isArray(vbLayout)) {
                    vbLayout = toLayoutObject(vbLayout);
                }
                if ((!(state.dataset && state.dataset.id) && state.flow) ||
                    (state.dataset &&
                        state.dataset.id &&
                        state.dataset.view_options &&
                        state.dataset.view_options.list &&
                        state.dataset.view_options.list.flow)) {
                    state.vbLayout = clearGroupAreas(vbLayout);
                }
                else {
                    state.vbLayout = vbLayout;
                }
                // in the initial implementation, we use layout as an array, so this object was mistakenly
                // transformed between an object and array. A proper fix should be changing all
                // related code to use object instead of array
                var newVbLayout = __assign({}, vbLayout);
                state.layout = toLayout(currentState.layout, newVbLayout, currentState.portrait, currentState.scale);
                break;
            }
            case OPEN_COMPONENT_LIST:
                state.componentListIsOpen = true;
                break;
            case OVERRIDE_STYLE: {
                if (state.selectedTab && state.selectedTab !== 'default') {
                    var newLayoutState = JSON.parse(JSON.stringify(currentState.layout));
                    newLayoutState[action.componentId].component_states[state.selectedTab].properties.overrideStyle = action.checked;
                    var styledLayout = transformLayoutWithStyle(newLayoutState, currentState.style);
                    state.vbLayout = toVBLayout(styledLayout, currentState.portrait, currentState.scale);
                    state.layout[action.componentId].component_states[state.selectedTab].properties.overrideStyle = action.checked;
                    state.vbLayout[action.componentId].properties =
                        state.layout[action.componentId].component_states[state.selectedTab].properties;
                    state.vbLayout[action.componentId].properties.overrideStyle =
                        action.checked;
                }
                else {
                    var newLayoutState = JSON.parse(JSON.stringify(currentState.layout));
                    newLayoutState[action.componentId].properties.overrideStyle =
                        action.checked;
                    var styledLayout = transformLayoutWithStyle(newLayoutState, currentState.style);
                    state.vbLayout = toVBLayout(styledLayout, currentState.portrait, currentState.scale);
                    state.layout[action.componentId].properties.overrideStyle =
                        action.checked;
                    state.vbLayout[action.componentId].properties.overrideStyle =
                        action.checked;
                }
                state.saving = true;
                break;
            }
            case REMOVE_GRID_COMPONENT:
                delete state.layout[action.componentId];
                delete state.vbLayout[action.componentId];
                state.saving = true;
                break;
            case REMOVE_IO:
                state[action.ioType].splice(state[action.ioType].findIndex(function (io) { return io.id === action.id; }), 1);
                state.saving = true;
                break;
            case SAVE_LAYOUT_FAILURE:
                state.saving = false;
                state.error = action.err;
                break;
            case SAVE_LAYOUT_REQUEST:
                state.saving = true;
                state.error = false;
                break;
            case SAVE_LAYOUT_SUCCESS:
                state.saving = false;
                state.error = false;
                break;
            case SAVE_DATASET_NON_LIST_LAYOUT_FAILURE:
                state.saving = false;
                state.error = action.err;
                break;
            case SAVE_DATASET_NON_LIST_LAYOUT_REQUEST:
                state.saving = true;
                state.error = false;
                state.dataset.view_options = __assign({}, action.payload.view_options);
                break;
            case SAVE_DATASET_NON_LIST_LAYOUT_SUCCESS:
                state.saving = false;
                state.error = false;
                break;
            case SAVE_LIST_VIEW_LAYOUT_REQUEST: {
                state.saving = true;
                state.error = false;
                if (action.listType === 'calendar')
                    state.calendar = __assign(__assign({}, state.calendar), action.layoutData);
                else if (action.listType === 'map')
                    state.map = __assign(__assign({}, state.map), action.layoutData);
                else if (action.listType === 'grid')
                    state.grid = __assign(__assign({}, state.grid), action.layoutData);
                break;
            }
            case SELECT_GRID_COMPONENT:
                if (currentState.selectedComponentId !== action.componentId) {
                    state.selectedTab = 'default';
                    if ((_138 = state === null || state === void 0 ? void 0 : state.layout[currentState === null || currentState === void 0 ? void 0 : currentState.selectedComponentId]) === null || _138 === void 0 ? void 0 : _138.properties) {
                        state.vbLayout[currentState.selectedComponentId].properties =
                            state.layout[currentState.selectedComponentId].properties;
                    }
                }
                state.selectedComponentId = action.componentId;
                state.componentListIsOpen = false;
                break;
            case SET_NAME:
                state.name = action.name;
                state.saving = true;
                break;
            case LOAD_FOLDERS_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_FOLDERS_SUCCESS:
                state.folders = action.folders;
                state.foldersMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case LOAD_FOLDERS_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case LOAD_STORAGE_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_STORAGE_SUCCESS:
                state.loading = false;
                state.error = false;
                state.localStorage = action.localStorage || [];
                break;
            case LOAD_STORAGE_FAILURE:
                state.loading = false;
                state.error = true;
                state.localStorage = [];
                break;
            case LOAD_FILES_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_FILES_SUCCESS:
                state.files = action.files;
                state.icons = action.icons;
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case LOAD_FILES_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case GET_DATASET_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case GET_DATASET_SUCCESS: {
                state.hasLandscape = currentState.hasLandscape;
                state.type = action.dataset.type;
                state.meta = action.meta;
                state.inputs = action.fields;
                state.outputs = ((_141 = (_140 = (_139 = action.dataset) === null || _139 === void 0 ? void 0 : _139.view_options) === null || _140 === void 0 ? void 0 : _140.list) === null || _141 === void 0 ? void 0 : _141.outputs) || [];
                state.unstyledLayout = JSON.parse(JSON.stringify(action.layout || {}));
                state.layout = JSON.parse(JSON.stringify(action.layout || {}));
                var styledLayout = transformLayoutWithStyle(state.layout, state.style);
                state.vbLayout = toVBLayout(styledLayout, currentState.portrait, currentState.scale);
                state.padding = action.padding;
                if (Object.keys(state.layout).length > 0) {
                    state.componentListIsOpen = false;
                }
                state.bgColor = action.background_color || 'unset';
                if (action.background_image) {
                    state.bgImage = action.background_image;
                }
                state.overrideBackground =
                    state.bgColor !== 'unset' &&
                        (state.bgColor !== state.style.data.backgroundColor ||
                            state.bgImage.source !== '');
                state.dataset = __assign(__assign({}, initialState.dataset), action.dataset);
                if (!state.dataset.view_options.list) {
                    state.dataset.view_options.list = {};
                }
                state.dataset.view_options.list.flow =
                    action.dataset &&
                        action.dataset.view_options &&
                        action.dataset.view_options.list &&
                        action.dataset.view_options.list.flow;
                state.dataset.view_options.list.hasLandscape =
                    action.dataset &&
                        action.dataset.view_options &&
                        action.dataset.view_options.list &&
                        action.dataset.view_options.list.hasLandscape;
                state.dataset.view_options.list.separator =
                    action.separator || initialState.dataset.view_options.list.separator;
                state.dataset.view_options.list.separatorColor =
                    action.separatorColor ||
                        initialState.dataset.view_options.list.separatorColor;
                state.dataset.view_options.list.separatorHeight =
                    action.separatorHeight ||
                        initialState.dataset.view_options.list.separatorHeight;
                state.dataset.view_options.list.groupingHeader =
                    action.groupingHeader ||
                        initialState.dataset.view_options.list.groupingHeader;
                state.overrideDatalistGroupingHeader =
                    state.dataset.view_options.list.groupingHeader.backgroundColor !==
                        initialState.dataset.view_options.list.groupingHeader
                            .backgroundColor ||
                        state.dataset.view_options.list.groupingHeader.fontColor !==
                            initialState.dataset.view_options.list.groupingHeader.fontColor ||
                        state.dataset.view_options.list.groupingHeader.fontFamily !==
                            initialState.dataset.view_options.list.groupingHeader.fontFamily ||
                        state.dataset.view_options.list.groupingHeader.fontSize !==
                            initialState.dataset.view_options.list.groupingHeader.fontSize ||
                        state.dataset.view_options.list.groupingHeader.fontWeight !==
                            initialState.dataset.view_options.list.groupingHeader.fontWeight;
                state.loading = false;
                state.error = false;
                break;
            }
            case GET_DATASET_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case RESET_BG_COLOR:
                state.bgColor = 'unset';
                state.overrideBackground = action.override;
                state.saving = true;
                break;
            case RESET_BG_IMAGE:
                state.bgImage = action.value;
                state.overrideBackground = action.override;
                state.saving = true;
                break;
            case CHANGE_VIEW_PADDING:
                state.padding[action.field] = action.value;
                state.saving = true;
                break;
            case SET_DATASET_SEPARATOR:
                if (state.type === 'list')
                    state.separator = true;
                else
                    state.dataset.view_options.list.separator = true;
                state.saving = true;
                break;
            case CHANGE_DATASET_SEPARATOR_COLOR:
                if (state.type === 'list')
                    state.separatorColor = action.value;
                else
                    state.dataset.view_options.list.separatorColor = action.value;
                state.saving = true;
                break;
            case CHANGE_DATASET_SEPARATOR_HEIGHT:
                if (state.type === 'list')
                    state.separatorHeight = action.value;
                else
                    state.dataset.view_options.list.separatorHeight = action.value;
                state.saving = true;
                break;
            case RESET_DATASET_SEPARATOR:
                if (state.type === 'list') {
                    state.separator = false;
                    state.separatorColor = initialState.separatorColor;
                    state.separatorHeight = initialState.separatorHeight;
                }
                else {
                    state.dataset.view_options.list.separator = false;
                    state.dataset.view_options.list.separatorColor =
                        initialState.dataset.view_options.list.separatorColor;
                    state.dataset.view_options.list.separatorHeight =
                        initialState.dataset.view_options.list.separatorHeight;
                }
                state.saving = true;
                break;
            case TOGGLE_LIST_ITEM_BORDER:
                if (state.enableListItemBorder) {
                    // reset
                    state.listItemBorder = initialState.listItemBorder;
                }
                state.enableListItemBorder = !state.enableListItemBorder;
                break;
            case SET_LIST_ITEM_BORDER_PROPERTY:
                state.listItemBorder[action.property] = action.value;
                break;
            case ENABLE_OVERRIDE_DATASET_LIST_GROUPING_HEADER:
                state.overrideDatalistGroupingHeader = action.value;
                state.saving = true;
                break;
            case CHANGE_DATASET_LIST_GROUPING_HEADER_FIELDS:
                if (state.type === 'list')
                    state.groupingHeader[action.field] = action.value;
                else
                    state.dataset.view_options.list.groupingHeader[action.field] =
                        action.value;
                state.saving = true;
                break;
            case RESET_DATASET_LIST_GROUPING_HEADER_FIELDS:
                if (state.type === 'list')
                    state.groupingHeader[action.field] =
                        initialState.groupingHeader[action.field];
                else
                    state.dataset.view_options.list.groupingHeader[action.field] =
                        initialState.dataset.view_options.list.groupingHeader[action.field];
                state.saving = true;
                break;
            case SET_FULLSCREEN:
                state.fullscreen = action.value;
                if (state.fullscreen) {
                    state.flow = false;
                }
                state.saving = true;
                break;
            case SET_FLOW:
                state.flow = action.value;
                if (state.flow) {
                    state.fullscreen = false;
                }
                if (state.dataset) {
                    state.dataset.view_options.list.flow = action.value;
                }
                state.saving = true;
                break;
            case TOGGLE_ORIENTATION:
                state.hasLandscape = action.value;
                if (!state.portrait && !action.value) {
                    state.portrait = true;
                    state.vbLayout = toVBLayout(currentState.layout, true, currentState.scale);
                }
                if (state.dataset) {
                    state.dataset.view_options.list.hasLandscape = action.value;
                }
                state.saving = true;
                break;
            case TOGGLE_FONT_SCALLING:
                state.fontScalingAllowed = action.value;
                break;
            case CHANGE_COMPONENT_DIMENSIONS:
                state.vbLayout[action.componentId][action.field] = action.value;
                state.saving = true;
                break;
            case UPDATE_GROUPED_SELECTED_COMPONENTS:
                if (!!action.componentId) {
                    state.selectedComponentId = action.componentId;
                    var groupedSet = new Set(currentState.groupedSelectedComponents);
                    if (currentState.selectedComponentId) {
                        groupedSet.add(currentState.selectedComponentId);
                    }
                    if (currentState.groupedSelectedComponents.includes(action.componentId)) {
                        groupedSet.delete(action.componentId);
                    }
                    else {
                        groupedSet.add(action.componentId);
                    }
                    var newGroup = groupedSet.size > 0 ? Array.from(groupedSet.values()) : [];
                    if (newGroup.length === 1) {
                        // eslint-disable-next-line prefer-destructuring
                        state.selectedComponentId = newGroup[0];
                    }
                    state.groupedSelectedComponents = newGroup;
                }
                else {
                    state.groupedSelectedComponents = [];
                }
                state.componentListIsOpen = false;
                break;
            case UPDATE_GROUP_SELECTION:
                state.groupedSelectedComponents = action.componentIds;
                break;
            case GET_DATASET_ROWS_REQUEST:
                state.error = false;
                break;
            case GET_DATASET_ROWS_SUCCESS:
                state.datasetRows = action.datasetRows;
                state.error = false;
                break;
            case GET_DATASET_ROWS_FAILURE:
                state.error = true;
                break;
            case UPDATE_SELECTED_TAB:
                if (state.layout[currentState.selectedComponentId].component_states &&
                    Object.keys(state.layout[currentState.selectedComponentId].component_states).includes(action.tab)) {
                    state.selectedTab = action.tab;
                    if (state.layout[currentState.selectedComponentId].component_states &&
                        Object.keys(state.layout[currentState.selectedComponentId].component_states).length > 0 &&
                        ((_142 = state.layout[currentState.selectedComponentId].component_states[action.tab]) === null || _142 === void 0 ? void 0 : _142.properties)) {
                        state.vbLayout[currentState.selectedComponentId].properties =
                            state.layout[currentState.selectedComponentId].component_states[action.tab].properties;
                    }
                    else {
                        state.vbLayout[currentState.selectedComponentId].properties =
                            state.layout[currentState.selectedComponentId].properties;
                    }
                }
                else {
                    state.selectedTab = 'default';
                    state.vbLayout[currentState.selectedComponentId].properties =
                        state.layout[currentState.selectedComponentId].properties;
                }
                break;
            case ADD_COMPONENT_STATE_SELECTED_COMPONENT:
                var newLayout = __assign({}, state.layout);
                var selectedComponent = __assign({}, newLayout[state.selectedComponentId]);
                if ((selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.component_states) &&
                    Object.keys(selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.component_states).length > 0) {
                    selectedComponent = __assign(__assign({}, selectedComponent), { component_states: __assign(__assign({}, selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.component_states), (_e = {}, _e[action.state] = {
                            conditions: {},
                            properties: action.props,
                        }, _e)) });
                }
                else {
                    selectedComponent = __assign(__assign({}, selectedComponent), { component_states: (_f = {},
                            _f[action.state] = {
                                conditions: {},
                                properties: action.props,
                            },
                            _f) });
                }
                newLayout[state.selectedComponentId] = __assign({}, selectedComponent);
                state.layout = __assign({}, newLayout);
                state.selectedTab = action.state;
                if (action.state && action.state !== 'default') {
                    if (state.layout[currentState.selectedComponentId].component_states &&
                        Object.keys(state.layout[currentState.selectedComponentId].component_states).length > 0 &&
                        ((_143 = state.layout[currentState.selectedComponentId].component_states[action.state]) === null || _143 === void 0 ? void 0 : _143.properties)) {
                        state.vbLayout[currentState.selectedComponentId].properties =
                            state.layout[currentState.selectedComponentId].component_states[action.state].properties;
                    }
                    else {
                        state.vbLayout[currentState.selectedComponentId].properties =
                            state.layout[currentState.selectedComponentId].properties;
                    }
                }
                else {
                    state.vbLayout[currentState.selectedComponentId].properties =
                        state.layout[currentState.selectedComponentId].properties;
                }
                state.saving = true;
                break;
            case UPDATE_LOGIC_SELECETD_COMPONENT_STATE: {
                var newLayout_2 = __assign({}, currentState.layout);
                var selectedComponent_1 = __assign({}, newLayout_2[currentState.selectedComponentId]);
                selectedComponent_1 = __assign(__assign({}, selectedComponent_1), { component_states: __assign(__assign({}, selectedComponent_1 === null || selectedComponent_1 === void 0 ? void 0 : selectedComponent_1.component_states), (_g = {}, _g[currentState.selectedTab] = __assign(__assign({}, selectedComponent_1 === null || selectedComponent_1 === void 0 ? void 0 : selectedComponent_1.component_states[currentState.selectedTab]), { conditions: action.logic || {} }), _g)) });
                newLayout_2[currentState.selectedComponentId] = __assign({}, selectedComponent_1);
                state.layout = __assign({}, newLayout_2);
                state.saving = true;
                break;
            }
            case DELETE_COMPONENT_STATE: {
                var newLayout_3 = currentState.layout;
                var selectedComponent_2 = newLayout_3[currentState.selectedComponentId];
                var component_states = selectedComponent_2.component_states;
                var newStates = Object.keys(component_states).filter(function (s) { return action.state !== s; });
                var newComponentStates = {};
                for (var _i = 0, newStates_1 = newStates; _i < newStates_1.length; _i++) {
                    var s = newStates_1[_i];
                    newComponentStates[s] = component_states[s];
                }
                selectedComponent_2 = __assign(__assign({}, selectedComponent_2), { component_states: __assign({}, newComponentStates) });
                newLayout_3[currentState.selectedComponentId] = __assign({}, selectedComponent_2);
                state.selectedTab = 'default';
                state.layout = __assign({}, newLayout_3);
                state.saving = true;
                break;
            }
            case UPDATE_COMPONENT_STATE_NAME:
                if (action.old !== action.new) {
                    var newLayout_4 = currentState.layout;
                    var selectedComponent_3 = newLayout_4[currentState.selectedComponentId];
                    var _144 = selectedComponent_3.component_states, component_states = _144 === void 0 ? {} : _144;
                    if (component_states &&
                        (selectedComponent_3 === null || selectedComponent_3 === void 0 ? void 0 : selectedComponent_3.component_states[action.old]) &&
                        Object.keys(selectedComponent_3 === null || selectedComponent_3 === void 0 ? void 0 : selectedComponent_3.component_states[action.old])
                            .length > 0) {
                        var newStates = Object.keys(component_states);
                        var newComponentStates = {};
                        for (var _145 = 0, newStates_2 = newStates; _145 < newStates_2.length; _145++) {
                            var state_1 = newStates_2[_145];
                            if (state_1 !== action.old) {
                                newComponentStates[state_1] = component_states[state_1];
                            }
                            else {
                                newComponentStates[action.new] =
                                    selectedComponent_3 === null || selectedComponent_3 === void 0 ? void 0 : selectedComponent_3.component_states[action.old];
                            }
                        }
                        selectedComponent_3 = __assign(__assign({}, selectedComponent_3), { component_states: __assign({}, newComponentStates) });
                        newLayout_4[currentState.selectedComponentId] = __assign({}, selectedComponent_3);
                        state.layout = __assign({}, newLayout_4);
                        state.selectedTab = action.new;
                        state.saving = true;
                    }
                }
                break;
            case COPY_COMPONENT_STATE: {
                var newLayout_5 = currentState.layout;
                var selectedComponent_4 = newLayout_5[currentState.selectedComponentId];
                var _146 = selectedComponent_4.component_states, component_states = _146 === void 0 ? {} : _146;
                var newState_1 = "".concat(action.state, "_copy");
                if (Object.keys(component_states).includes(newState_1)) {
                    var noOfStateCopies = Object.keys(component_states).filter(function (state) {
                        return state.includes(newState_1);
                    }).length;
                    if (noOfStateCopies > 0) {
                        newState_1 = "".concat(newState_1, "_").concat(noOfStateCopies + 1);
                    }
                }
                var new_component_states = __assign(__assign({}, component_states), (_h = {}, _h[newState_1] = component_states[action.state], _h));
                selectedComponent_4.component_states = __assign({}, new_component_states);
                newLayout_5[currentState.selectedComponentId] = __assign({}, selectedComponent_4);
                state.layout = __assign({}, newLayout_5);
                state.selectedTab = newState_1;
                state.saving = true;
                break;
            }
            case GET_DATASET_RULES_REQUEST:
                state.error = false;
                break;
            case GET_DATASET_RULES_SUCCESS:
                state.error = false;
                state.datasetRules = action.datasetRules;
                break;
            case GET_DATASET_RULES_FAILURE:
                state.error = true;
                break;
            default:
                break;
        }
        if (!(state.dataset && state.dataset.id) && state.flow) {
            compactFlowLayout(state.layout, state.portrait);
            compactFlowLayout(state.vbLayout, state.portrait);
        }
        if (state.dataset &&
            state.dataset.id &&
            state.dataset.view_options &&
            state.dataset.view_options.list &&
            state.dataset.view_options.list.flow) {
            compactFlowLayout(state.layout, state.portrait);
            compactFlowLayout(state.vbLayout, state.portrait);
        }
        return state;
    });
}
export default colourPreviewReducer;
